<script lang="ts" setup>
import OmniSelect from "@/components/selects/OmniSelect.vue";
import type { TimezoneSelectProps } from "@/types/props";
import { useDateTime } from "@/composables";
import { computed } from "vue";

const { getLongTZForDate } = useDateTime();

const model = defineModel<string | null>({ default: null });

const props = withDefaults(defineProps<TimezoneSelectProps>(), {
  label: "Time zone",
  showFullTimezone: false,
});

const selection = computed(() => {
  return model.value ? getLongTZForDate(model.value) : null;
});
</script>

<template>
  <omni-select data-qa="timezone" v-bind="props" @update:model-value="model = $event">
    <template v-if="showFullTimezone && selection" #selection>
      <span class="selection">{{ selection }}</span>
    </template>
  </omni-select>
</template>

<style lang="scss" scoped>
.selection {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
